import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { getProfileId } from '@/utils/profile';

export const documentAddRoute: RouteConfig = {
  name: 'documentAdd',
  path: 'add',
  beforeEnter: (to, from, next) =>
    store
      .dispatch('document/add', {
        procedureId: tryParseInt(to.params.procedureId),
        creatorId: getProfileId(),
        data: {}
      })
      .then(documentId => next({ name: 'documentEdit', params: { documentId } }))
      .catch(err => store.dispatch('notifyError', { title: Errors.FORM_CANNOT_GET }))
};
